import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import * as listActions from '../list/actions';
import store from '../../../../store';

function* publishAssignment({ payload: { id, onSuccess, handledErrors } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.updatePatch, id, data: { status: 'published' } });

    dispatch(listActions.getAssignmentsRequest({ status: 'draft', curr_page: getState().getAssignments.curr_page }));

    onSuccess && onSuccess();
    yield put(actions.publishAssignmentDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.publishAssignmentFailed,
      handledErrors,
      endpoint: api.modifiers.assignments.update.url
    });
  }
}

export const publishAssignmentSaga = takeEvery(types.PUBLISH_ASSIGNMENT_REQUEST, publishAssignment);